import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'callout',
  templateUrl: './callout.component.html',
  styleUrls: ['./callout.component.css']
})
export class CalloutComponent implements OnInit {
  @Input() text:string;

  constructor() { }

  ngOnInit() {
  }

}
